import { Hyperlink } from './hyperlink'

export const components = {
  hyperlink: Hyperlink
}